import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import '../Assets/Css/contact.css';
import productbanner from '../Assets/Images/Aboutbanner1.avif';
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';

import { toast, Toaster } from 'react-hot-toast';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import { BASE_URL } from '../BaseURL';

import { Helmet } from "react-helmet";

export default function Contact() {
  const [formData, setFormData] = useState({
    userName: '',
       email: '',
       mobile:'',
       requirements:'',
       address:'',
       message: ''
   });

   const [loading, setLoading] = useState(false);

 const handleChange = (e) => {
   const { name, value } = e.target;
   setFormData({
     ...formData,
     [name]: value,
   });
 };

 const handleSubmit = async (e) => {
   e.preventDefault();

   setLoading(true);

   try {
     const response = await axios.post(`${BASE_URL}/enquiry/sendContactEnquiry`, formData);
     if (response.status === 200) {
       toast.success("Enquiry sent successfully!");
     }
   } catch (error) {
     toast.error("Failed to send enquiry.");
   } finally {
     setLoading(false);
   }
 };

  return (
    <>
      <Toaster />
      <div className="mainnav">
      <Helmet>
        <title>Contact Us | Siddhi International</title>
        <meta name="description" content="Get in touch with Siddhi International for trusted trade, manufacturing, and legal solutions. Visit our Registrar and Admin offices in Palghar, Maharashtra or contact us via email or phone." />
        <meta name="keywords" content="Contact Siddhi International, Trade Solutions, Manufacturing Services, Legal Help, Palghar Office, Maharashtra, Email, Phone, Registrar Office, Admin Office, Connect with us" />
        <meta name="author" content="Siddhi International" />
        <meta property="og:title" content="Contact Us | Siddhi International" />
        <meta property="og:description" content="Reach out to Siddhi International for trusted business solutions. Connect with us at our Palghar offices or online." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://siddhinternational.com/contact" />
        <meta property="og:image" content="https://siddhinternational.com/images/contact-banner.jpg" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://siddhinternational.com/contact" />
      </Helmet>

        {/* Banner Section */}
    

        <div className="about-banner position-relative text-white">
  <img
    src={productbanner}
    alt="About Banner"
    className="aboutbanner-image "
  />
  
  <div className="container d-flex justify-content-center align-items-center h-100">
    <div className="row w-100 justify-content-center">
      <div className="col-12 col-md-6 px-3">
        <div className="maindesc">
          <h2 className="fw-bold">
          Connect With Us
          </h2>
          <p className="lead">
          Contact us for trusted trade, manufacturing, and legal solutions.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>


        {/* Contact Info Section */}
        <Container className=" py-4">
          <Row className="text-center mb-4">
            <Col>
              <h2 className="Mainhead">Get in Touch</h2>

            </Col>
          </Row>

         


          <Row className="g-1 contact-section">
            <Col md={6}>
              <Card className="h-100 contact-info-card">
                <Card.Body>
                  <h5 className="text-center fw-bold mb-4">Location</h5>

                  <div className="contact-info-item">
                    <MdLocationOn size={45} />
                    <p>
                      <strong>Registrar Office :-</strong> B/3, A 302, Narmada Vihar Tarapur Road, opposite circle Office, Kurgaon, District Palghar, Maharashtra, India. 401502.
                    </p>
                  </div>

                  <div className="contact-info-item">
                    <MdLocationOn size={40} />
                    <p>
                      <strong>Admin Office :-</strong> B/5, Next Moll, Near Parag Hospital, Plot No. P 20-21, Chitralaya, MIDC Tarapur, District Palghar, Maharashtra, India. 401504
                    </p>
                  </div>

                  <a href="mailto:info@aimindproducts.com" className="contact-link">
                    <MdEmail size={20} />
                    <p><strong>Email —</strong> siddhiinternational5557@gmail.com</p>
                  </a>

                  <a href="https://wa.me/9561416140" target="_blank" rel="noopener noreferrer" className="contact-link">
                    <MdPhone size={20} />
                    <p><strong>Mobile -</strong> 9561416140</p>
                  </a>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="h-100 contact-form-card">
                <Card.Body>
                  <h5 className="text-center fw-bold mb-4">Contact Form</h5>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label className='fw-bold'>Name</Form.Label>
                      <Form.Control type="text" name="userName" value={formData.userName} onChange={handleChange} placeholder="Enter your name" required />
                    </Form.Group>
                    <Row >
<Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className='fw-bold'>Email</Form.Label>
                      <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" required />
                    </Form.Group>
                    </Col>

<Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className='fw-bold'>Mobile</Form.Label>
                      <Form.Control type="tel" name="mobile" value={formData.mobile} maxLength={10} onChange={handleChange} onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                      }} placeholder="Enter your mobile" required />
                    </Form.Group>
                    </Col>
                    </Row>

                    <Form.Group className="mb-3">
              <Form.Label className='fw-bold'>Requirements</Form.Label>
              <Form.Control
                type="text"
                name="requirements"
                value={formData.requirements}
                onChange={handleChange}
                placeholder="Enter your requirements"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className='fw-bold'>Address</Form.Label>
              <Form.Control
                as="textarea"
                name="address"
                value={formData.address}
                onChange={handleChange}
                rows={2}
                placeholder="Enter your address..."
                required
              />
            </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Label className='fw-bold'>Message</Form.Label>
                      <Form.Control as="textarea" name="message" value={formData.message} onChange={handleChange} rows={4} placeholder="Your message..." required />
                    </Form.Group>

                    <div className="d-grid justify-content-center">
                      <Button type="submit" className="contact-submit-btn" disabled={loading}>
                        {loading ? (
                          <>
                            <Spinner animation="border" size="sm" /> Sending...
                          </>
                        ) : (
                          'Submit'
                        )}
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
         
          </Row>

          <div className='mt-5'>
            <h3 className='Mainhead text-center mb-4'>Our Locations</h3>
            <div className="row g-4">

              {/* Location 1 */}
              <div className="col-md-6">
                <div className="map-card p-3 rounded shadow-sm h-100">
                  <h5 className="fw-bold mb-3">Registrar Office</h5>
                  <p>B/3, A 302, Narmada Vihar Tarapur Road, Opp. Circle Office, Kurgaon, Palghar, Maharashtra, 401502</p>
                  <div className="map-container mt-3">
                    <iframe
                      title="Registrar Office Map"
                      src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d120152.47451413612!2d72.66235886641437!3d19.76514380129154!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sB%2F3%2C%20A%20302%2C%20Narmada%20Vihar%20Tarapur%20Road%2C%20Opp.%20Circle%20Office%2C%20Kurgaon%2C%20Palghar%2C%20Maharashtra%2C%20401502!5e0!3m2!1sen!2sin!4v1745579255870!5m2!1sen!2sin"
                      width="100%"
                      height="200px"
                      allowfullscreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade">

                    </iframe>
                  </div>
                </div>
              </div>

              {/* Location 2 */}
              <div className="col-md-6">
                <div className="map-card p-3 rounded shadow-sm h-100">
                  <h5 className="fw-bold mb-3">Admin Office</h5>
                  <p>B/5, Next Moll, Near Parag Hospital, Plot No. P 20-21, Chitralaya, MIDC Tarapur, Palghar, Maharashtra, 401504</p>
                  <div className="map-container mt-3">


                    <iframe
                      title="Admin Office Map"
                      src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d17856.572128746324!2d72.72856076738732!3d19.802605221097032!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sB%2F5%2C%20Next%20Mall%2C%20Near%20Parag%20Hospital%2C%20Plot%20No.%20P%2020-21%2C%20Chitralaya%2C%20MIDC%20Tarapur%2C%20Palghar%2C%20Maharashtra%2C%20401504!5e0!3m2!1sen!2sin!4v1745579475681!5m2!1sen!2sin"
                      width="100%"
                      height="200px"
                      allowfullscreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"></iframe>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>

      </div>
    </>
  );
}
